/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ContentRouteImport } from './routes/_content'
import { Route as PendingApprovalRouteImport } from './routes/pending-approval'
import { Route as SupportRouteImport } from './routes/support'
import { Route as ContentMainRouteImport } from './routes/_content/main'
import { Route as ContentMypageRouteImport } from './routes/_content/mypage'
import { Route as ContentOfficesRouteImport } from './routes/_content/offices'
import { Route as ContentPermissionRouteImport } from './routes/_content/permission'
import { Route as ContentTeachersRouteImport } from './routes/_content/teachers'
import { Route as AuthFindIdRouteImport } from './routes/auth/find-id'
import { Route as AuthFindPasswordRouteImport } from './routes/auth/find-password'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as TermIdRouteImport } from './routes/term/$id'
import { Route as VocabularyPrintRouteImport } from './routes/vocabulary/print'
import { Route as ContentClassesIndexRouteImport } from './routes/_content/classes/index'
import { Route as ContentCompetitionIndexRouteImport } from './routes/_content/competition/index'
import { Route as ContentCompetitionGameIdRouteImport } from './routes/_content/competition/$gameId'
import { Route as ContentCompetitionDemoRouteImport } from './routes/_content/competition/demo'
import { Route as ContentCompetitionGroupsRouteImport } from './routes/_content/competition/groups'
import { Route as ContentNoticeIndexRouteImport } from './routes/_content/notice/index'
import { Route as ContentNoticeCategoriesRouteImport } from './routes/_content/notice/categories'
import { Route as ContentNoticeNewRouteImport } from './routes/_content/notice/new'
import { Route as ContentSettingsTestModeRouteImport } from './routes/_content/settings/test-mode'
import { Route as ContentStudentsIndexRouteImport } from './routes/_content/students/index'
import { Route as ContentTasksIndexRouteImport } from './routes/_content/tasks/index'
import { Route as ContentTasksCalendarRouteImport } from './routes/_content/tasks/calendar'
import { Route as ContentTasksNewRouteImport } from './routes/_content/tasks/new'
import { Route as ContentTasksStatsRouteImport } from './routes/_content/tasks/stats'
import { Route as ContentTasksUploadRouteImport } from './routes/_content/tasks/upload'
import { Route as ContentTermsIndexRouteImport } from './routes/_content/terms/index'
import { Route as AuthSignupIndexRouteImport } from './routes/auth/signup/index'
import { Route as AuthSignupParentKmcVerificationRouteImport } from './routes/auth/signup/parent-kmc-verification'
import { Route as AuthSignupPersonalSmsVerificationRouteImport } from './routes/auth/signup/personal-sms-verification'
import { Route as AuthSignupRequiredTermRouteImport } from './routes/auth/signup/required-term'
import { Route as AuthSignupSignupFormRouteImport } from './routes/auth/signup/signup-form'
import { Route as AuthSignupUnder14SmsVerificationRouteImport } from './routes/auth/signup/under-14-sms-verification'
import { Route as ContentClassesIdIndexRouteImport } from './routes/_content/classes/$id/index'
import { Route as ContentClassesIdStudentsRouteImport } from './routes/_content/classes/$id/students'
import { Route as ContentNoticeIdIndexRouteImport } from './routes/_content/notice/$id/index'
import { Route as ContentNoticeIdEditRouteImport } from './routes/_content/notice/$id/edit'
import { Route as ContentStudentsIdStatisticsRouteImport } from './routes/_content/students/$id/statistics'
import { Route as ContentTasksIdEditRouteImport } from './routes/_content/tasks/$id/edit'
import { Route as ContentTasksRankingIdRouteImport } from './routes/_content/tasks/ranking/$id'
import { Route as ContentTermsSlugEditRouteImport } from './routes/_content/terms/$slug/edit'
import { Route as ContentVocabularyCategoriesIndexRouteImport } from './routes/_content/vocabulary/categories/index'
import { Route as ContentVocabularyCategoriesIdSentencesIndexRouteImport } from './routes/_content/vocabulary/categories/$id/sentences/index'
import { Route as ContentVocabularyCategoriesIdWordsIndexRouteImport } from './routes/_content/vocabulary/categories/$id/words/index'
import { Route as ContentVocabularyCategoriesIdWordsUploadRouteImport } from './routes/_content/vocabulary/categories/$id/words/upload'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContentRoute = ContentRouteImport.update({
  id: '/_content',
  getParentRoute: () => rootRouteImport,
} as any)
const PendingApprovalRoute = PendingApprovalRouteImport.update({
  id: '/pending-approval',
  path: '/pending-approval',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const ContentMainRoute = ContentMainRouteImport.update({
  id: '/main',
  path: '/main',
  getParentRoute: () => ContentRoute,
} as any)
const ContentMypageRoute = ContentMypageRouteImport.update({
  id: '/mypage',
  path: '/mypage',
  getParentRoute: () => ContentRoute,
} as any)
const ContentOfficesRoute = ContentOfficesRouteImport.update({
  id: '/offices',
  path: '/offices',
  getParentRoute: () => ContentRoute,
} as any)
const ContentPermissionRoute = ContentPermissionRouteImport.update({
  id: '/permission',
  path: '/permission',
  getParentRoute: () => ContentRoute,
} as any)
const ContentTeachersRoute = ContentTeachersRouteImport.update({
  id: '/teachers',
  path: '/teachers',
  getParentRoute: () => ContentRoute,
} as any)
const AuthFindIdRoute = AuthFindIdRouteImport.update({
  id: '/auth/find-id',
  path: '/auth/find-id',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthFindPasswordRoute = AuthFindPasswordRouteImport.update({
  id: '/auth/find-password',
  path: '/auth/find-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const TermIdRoute = TermIdRouteImport.update({
  id: '/term/$id',
  path: '/term/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const VocabularyPrintRoute = VocabularyPrintRouteImport.update({
  id: '/vocabulary/print',
  path: '/vocabulary/print',
  getParentRoute: () => rootRouteImport,
} as any)
const ContentClassesIndexRoute = ContentClassesIndexRouteImport.update({
  id: '/classes/',
  path: '/classes/',
  getParentRoute: () => ContentRoute,
} as any)
const ContentCompetitionIndexRoute = ContentCompetitionIndexRouteImport.update({
  id: '/competition/',
  path: '/competition/',
  getParentRoute: () => ContentRoute,
} as any)
const ContentCompetitionGameIdRoute =
  ContentCompetitionGameIdRouteImport.update({
    id: '/competition/$gameId',
    path: '/competition/$gameId',
    getParentRoute: () => ContentRoute,
  } as any)
const ContentCompetitionDemoRoute = ContentCompetitionDemoRouteImport.update({
  id: '/competition/demo',
  path: '/competition/demo',
  getParentRoute: () => ContentRoute,
} as any)
const ContentCompetitionGroupsRoute =
  ContentCompetitionGroupsRouteImport.update({
    id: '/competition/groups',
    path: '/competition/groups',
    getParentRoute: () => ContentRoute,
  } as any)
const ContentNoticeIndexRoute = ContentNoticeIndexRouteImport.update({
  id: '/notice/',
  path: '/notice/',
  getParentRoute: () => ContentRoute,
} as any)
const ContentNoticeCategoriesRoute = ContentNoticeCategoriesRouteImport.update({
  id: '/notice/categories',
  path: '/notice/categories',
  getParentRoute: () => ContentRoute,
} as any)
const ContentNoticeNewRoute = ContentNoticeNewRouteImport.update({
  id: '/notice/new',
  path: '/notice/new',
  getParentRoute: () => ContentRoute,
} as any)
const ContentSettingsTestModeRoute = ContentSettingsTestModeRouteImport.update({
  id: '/settings/test-mode',
  path: '/settings/test-mode',
  getParentRoute: () => ContentRoute,
} as any)
const ContentStudentsIndexRoute = ContentStudentsIndexRouteImport.update({
  id: '/students/',
  path: '/students/',
  getParentRoute: () => ContentRoute,
} as any)
const ContentTasksIndexRoute = ContentTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => ContentRoute,
} as any)
const ContentTasksCalendarRoute = ContentTasksCalendarRouteImport.update({
  id: '/tasks/calendar',
  path: '/tasks/calendar',
  getParentRoute: () => ContentRoute,
} as any)
const ContentTasksNewRoute = ContentTasksNewRouteImport.update({
  id: '/tasks/new',
  path: '/tasks/new',
  getParentRoute: () => ContentRoute,
} as any)
const ContentTasksStatsRoute = ContentTasksStatsRouteImport.update({
  id: '/tasks/stats',
  path: '/tasks/stats',
  getParentRoute: () => ContentRoute,
} as any)
const ContentTasksUploadRoute = ContentTasksUploadRouteImport.update({
  id: '/tasks/upload',
  path: '/tasks/upload',
  getParentRoute: () => ContentRoute,
} as any)
const ContentTermsIndexRoute = ContentTermsIndexRouteImport.update({
  id: '/terms/',
  path: '/terms/',
  getParentRoute: () => ContentRoute,
} as any)
const AuthSignupIndexRoute = AuthSignupIndexRouteImport.update({
  id: '/auth/signup/',
  path: '/auth/signup/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupParentKmcVerificationRoute =
  AuthSignupParentKmcVerificationRouteImport.update({
    id: '/auth/signup/parent-kmc-verification',
    path: '/auth/signup/parent-kmc-verification',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthSignupPersonalSmsVerificationRoute =
  AuthSignupPersonalSmsVerificationRouteImport.update({
    id: '/auth/signup/personal-sms-verification',
    path: '/auth/signup/personal-sms-verification',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthSignupRequiredTermRoute = AuthSignupRequiredTermRouteImport.update({
  id: '/auth/signup/required-term',
  path: '/auth/signup/required-term',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupSignupFormRoute = AuthSignupSignupFormRouteImport.update({
  id: '/auth/signup/signup-form',
  path: '/auth/signup/signup-form',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupUnder14SmsVerificationRoute =
  AuthSignupUnder14SmsVerificationRouteImport.update({
    id: '/auth/signup/under-14-sms-verification',
    path: '/auth/signup/under-14-sms-verification',
    getParentRoute: () => rootRouteImport,
  } as any)
const ContentClassesIdIndexRoute = ContentClassesIdIndexRouteImport.update({
  id: '/classes/$id/',
  path: '/classes/$id/',
  getParentRoute: () => ContentRoute,
} as any)
const ContentClassesIdStudentsRoute =
  ContentClassesIdStudentsRouteImport.update({
    id: '/classes/$id/students',
    path: '/classes/$id/students',
    getParentRoute: () => ContentRoute,
  } as any)
const ContentNoticeIdIndexRoute = ContentNoticeIdIndexRouteImport.update({
  id: '/notice/$id/',
  path: '/notice/$id/',
  getParentRoute: () => ContentRoute,
} as any)
const ContentNoticeIdEditRoute = ContentNoticeIdEditRouteImport.update({
  id: '/notice/$id/edit',
  path: '/notice/$id/edit',
  getParentRoute: () => ContentRoute,
} as any)
const ContentStudentsIdStatisticsRoute =
  ContentStudentsIdStatisticsRouteImport.update({
    id: '/students/$id/statistics',
    path: '/students/$id/statistics',
    getParentRoute: () => ContentRoute,
  } as any)
const ContentTasksIdEditRoute = ContentTasksIdEditRouteImport.update({
  id: '/tasks/$id/edit',
  path: '/tasks/$id/edit',
  getParentRoute: () => ContentRoute,
} as any)
const ContentTasksRankingIdRoute = ContentTasksRankingIdRouteImport.update({
  id: '/tasks/ranking/$id',
  path: '/tasks/ranking/$id',
  getParentRoute: () => ContentRoute,
} as any)
const ContentTermsSlugEditRoute = ContentTermsSlugEditRouteImport.update({
  id: '/terms/$slug/edit',
  path: '/terms/$slug/edit',
  getParentRoute: () => ContentRoute,
} as any)
const ContentVocabularyCategoriesIndexRoute =
  ContentVocabularyCategoriesIndexRouteImport.update({
    id: '/vocabulary/categories/',
    path: '/vocabulary/categories/',
    getParentRoute: () => ContentRoute,
  } as any)
const ContentVocabularyCategoriesIdSentencesIndexRoute =
  ContentVocabularyCategoriesIdSentencesIndexRouteImport.update({
    id: '/vocabulary/categories/$id/sentences/',
    path: '/vocabulary/categories/$id/sentences/',
    getParentRoute: () => ContentRoute,
  } as any)
const ContentVocabularyCategoriesIdWordsIndexRoute =
  ContentVocabularyCategoriesIdWordsIndexRouteImport.update({
    id: '/vocabulary/categories/$id/words/',
    path: '/vocabulary/categories/$id/words/',
    getParentRoute: () => ContentRoute,
  } as any)
const ContentVocabularyCategoriesIdWordsUploadRoute =
  ContentVocabularyCategoriesIdWordsUploadRouteImport.update({
    id: '/vocabulary/categories/$id/words/upload',
    path: '/vocabulary/categories/$id/words/upload',
    getParentRoute: () => ContentRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/pending-approval': typeof PendingApprovalRoute
  '/support': typeof SupportRoute
  '/main': typeof ContentMainRoute
  '/mypage': typeof ContentMypageRoute
  '/offices': typeof ContentOfficesRoute
  '/permission': typeof ContentPermissionRoute
  '/teachers': typeof ContentTeachersRoute
  '/auth/find-id': typeof AuthFindIdRoute
  '/auth/find-password': typeof AuthFindPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/term/$id': typeof TermIdRoute
  '/vocabulary/print': typeof VocabularyPrintRoute
  '/competition/$gameId': typeof ContentCompetitionGameIdRoute
  '/competition/demo': typeof ContentCompetitionDemoRoute
  '/competition/groups': typeof ContentCompetitionGroupsRoute
  '/notice/categories': typeof ContentNoticeCategoriesRoute
  '/notice/new': typeof ContentNoticeNewRoute
  '/settings/test-mode': typeof ContentSettingsTestModeRoute
  '/tasks/calendar': typeof ContentTasksCalendarRoute
  '/tasks/new': typeof ContentTasksNewRoute
  '/tasks/stats': typeof ContentTasksStatsRoute
  '/tasks/upload': typeof ContentTasksUploadRoute
  '/auth/signup/parent-kmc-verification': typeof AuthSignupParentKmcVerificationRoute
  '/auth/signup/personal-sms-verification': typeof AuthSignupPersonalSmsVerificationRoute
  '/auth/signup/required-term': typeof AuthSignupRequiredTermRoute
  '/auth/signup/signup-form': typeof AuthSignupSignupFormRoute
  '/auth/signup/under-14-sms-verification': typeof AuthSignupUnder14SmsVerificationRoute
  '/classes/': typeof ContentClassesIndexRoute
  '/competition/': typeof ContentCompetitionIndexRoute
  '/notice/': typeof ContentNoticeIndexRoute
  '/students/': typeof ContentStudentsIndexRoute
  '/tasks/': typeof ContentTasksIndexRoute
  '/terms/': typeof ContentTermsIndexRoute
  '/auth/signup/': typeof AuthSignupIndexRoute
  '/classes/$id/students': typeof ContentClassesIdStudentsRoute
  '/notice/$id/edit': typeof ContentNoticeIdEditRoute
  '/students/$id/statistics': typeof ContentStudentsIdStatisticsRoute
  '/tasks/$id/edit': typeof ContentTasksIdEditRoute
  '/tasks/ranking/$id': typeof ContentTasksRankingIdRoute
  '/terms/$slug/edit': typeof ContentTermsSlugEditRoute
  '/classes/$id/': typeof ContentClassesIdIndexRoute
  '/notice/$id/': typeof ContentNoticeIdIndexRoute
  '/vocabulary/categories/': typeof ContentVocabularyCategoriesIndexRoute
  '/vocabulary/categories/$id/words/upload': typeof ContentVocabularyCategoriesIdWordsUploadRoute
  '/vocabulary/categories/$id/sentences/': typeof ContentVocabularyCategoriesIdSentencesIndexRoute
  '/vocabulary/categories/$id/words/': typeof ContentVocabularyCategoriesIdWordsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/pending-approval': typeof PendingApprovalRoute
  '/support': typeof SupportRoute
  '/main': typeof ContentMainRoute
  '/mypage': typeof ContentMypageRoute
  '/offices': typeof ContentOfficesRoute
  '/permission': typeof ContentPermissionRoute
  '/teachers': typeof ContentTeachersRoute
  '/auth/find-id': typeof AuthFindIdRoute
  '/auth/find-password': typeof AuthFindPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/term/$id': typeof TermIdRoute
  '/vocabulary/print': typeof VocabularyPrintRoute
  '/competition/$gameId': typeof ContentCompetitionGameIdRoute
  '/competition/demo': typeof ContentCompetitionDemoRoute
  '/competition/groups': typeof ContentCompetitionGroupsRoute
  '/notice/categories': typeof ContentNoticeCategoriesRoute
  '/notice/new': typeof ContentNoticeNewRoute
  '/settings/test-mode': typeof ContentSettingsTestModeRoute
  '/tasks/calendar': typeof ContentTasksCalendarRoute
  '/tasks/new': typeof ContentTasksNewRoute
  '/tasks/stats': typeof ContentTasksStatsRoute
  '/tasks/upload': typeof ContentTasksUploadRoute
  '/auth/signup/parent-kmc-verification': typeof AuthSignupParentKmcVerificationRoute
  '/auth/signup/personal-sms-verification': typeof AuthSignupPersonalSmsVerificationRoute
  '/auth/signup/required-term': typeof AuthSignupRequiredTermRoute
  '/auth/signup/signup-form': typeof AuthSignupSignupFormRoute
  '/auth/signup/under-14-sms-verification': typeof AuthSignupUnder14SmsVerificationRoute
  '/classes': typeof ContentClassesIndexRoute
  '/competition': typeof ContentCompetitionIndexRoute
  '/notice': typeof ContentNoticeIndexRoute
  '/students': typeof ContentStudentsIndexRoute
  '/tasks': typeof ContentTasksIndexRoute
  '/terms': typeof ContentTermsIndexRoute
  '/auth/signup': typeof AuthSignupIndexRoute
  '/classes/$id/students': typeof ContentClassesIdStudentsRoute
  '/notice/$id/edit': typeof ContentNoticeIdEditRoute
  '/students/$id/statistics': typeof ContentStudentsIdStatisticsRoute
  '/tasks/$id/edit': typeof ContentTasksIdEditRoute
  '/tasks/ranking/$id': typeof ContentTasksRankingIdRoute
  '/terms/$slug/edit': typeof ContentTermsSlugEditRoute
  '/classes/$id': typeof ContentClassesIdIndexRoute
  '/notice/$id': typeof ContentNoticeIdIndexRoute
  '/vocabulary/categories': typeof ContentVocabularyCategoriesIndexRoute
  '/vocabulary/categories/$id/words/upload': typeof ContentVocabularyCategoriesIdWordsUploadRoute
  '/vocabulary/categories/$id/sentences': typeof ContentVocabularyCategoriesIdSentencesIndexRoute
  '/vocabulary/categories/$id/words': typeof ContentVocabularyCategoriesIdWordsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_content': typeof ContentRouteWithChildren
  '/pending-approval': typeof PendingApprovalRoute
  '/support': typeof SupportRoute
  '/_content/main': typeof ContentMainRoute
  '/_content/mypage': typeof ContentMypageRoute
  '/_content/offices': typeof ContentOfficesRoute
  '/_content/permission': typeof ContentPermissionRoute
  '/_content/teachers': typeof ContentTeachersRoute
  '/auth/find-id': typeof AuthFindIdRoute
  '/auth/find-password': typeof AuthFindPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/term/$id': typeof TermIdRoute
  '/vocabulary/print': typeof VocabularyPrintRoute
  '/_content/competition/$gameId': typeof ContentCompetitionGameIdRoute
  '/_content/competition/demo': typeof ContentCompetitionDemoRoute
  '/_content/competition/groups': typeof ContentCompetitionGroupsRoute
  '/_content/notice/categories': typeof ContentNoticeCategoriesRoute
  '/_content/notice/new': typeof ContentNoticeNewRoute
  '/_content/settings/test-mode': typeof ContentSettingsTestModeRoute
  '/_content/tasks/calendar': typeof ContentTasksCalendarRoute
  '/_content/tasks/new': typeof ContentTasksNewRoute
  '/_content/tasks/stats': typeof ContentTasksStatsRoute
  '/_content/tasks/upload': typeof ContentTasksUploadRoute
  '/auth/signup/parent-kmc-verification': typeof AuthSignupParentKmcVerificationRoute
  '/auth/signup/personal-sms-verification': typeof AuthSignupPersonalSmsVerificationRoute
  '/auth/signup/required-term': typeof AuthSignupRequiredTermRoute
  '/auth/signup/signup-form': typeof AuthSignupSignupFormRoute
  '/auth/signup/under-14-sms-verification': typeof AuthSignupUnder14SmsVerificationRoute
  '/_content/classes/': typeof ContentClassesIndexRoute
  '/_content/competition/': typeof ContentCompetitionIndexRoute
  '/_content/notice/': typeof ContentNoticeIndexRoute
  '/_content/students/': typeof ContentStudentsIndexRoute
  '/_content/tasks/': typeof ContentTasksIndexRoute
  '/_content/terms/': typeof ContentTermsIndexRoute
  '/auth/signup/': typeof AuthSignupIndexRoute
  '/_content/classes/$id/students': typeof ContentClassesIdStudentsRoute
  '/_content/notice/$id/edit': typeof ContentNoticeIdEditRoute
  '/_content/students/$id/statistics': typeof ContentStudentsIdStatisticsRoute
  '/_content/tasks/$id/edit': typeof ContentTasksIdEditRoute
  '/_content/tasks/ranking/$id': typeof ContentTasksRankingIdRoute
  '/_content/terms/$slug/edit': typeof ContentTermsSlugEditRoute
  '/_content/classes/$id/': typeof ContentClassesIdIndexRoute
  '/_content/notice/$id/': typeof ContentNoticeIdIndexRoute
  '/_content/vocabulary/categories/': typeof ContentVocabularyCategoriesIndexRoute
  '/_content/vocabulary/categories/$id/words/upload': typeof ContentVocabularyCategoriesIdWordsUploadRoute
  '/_content/vocabulary/categories/$id/sentences/': typeof ContentVocabularyCategoriesIdSentencesIndexRoute
  '/_content/vocabulary/categories/$id/words/': typeof ContentVocabularyCategoriesIdWordsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/pending-approval'
    | '/support'
    | '/main'
    | '/mypage'
    | '/offices'
    | '/permission'
    | '/teachers'
    | '/auth/find-id'
    | '/auth/find-password'
    | '/auth/login'
    | '/term/$id'
    | '/vocabulary/print'
    | '/competition/$gameId'
    | '/competition/demo'
    | '/competition/groups'
    | '/notice/categories'
    | '/notice/new'
    | '/settings/test-mode'
    | '/tasks/calendar'
    | '/tasks/new'
    | '/tasks/stats'
    | '/tasks/upload'
    | '/auth/signup/parent-kmc-verification'
    | '/auth/signup/personal-sms-verification'
    | '/auth/signup/required-term'
    | '/auth/signup/signup-form'
    | '/auth/signup/under-14-sms-verification'
    | '/classes/'
    | '/competition/'
    | '/notice/'
    | '/students/'
    | '/tasks/'
    | '/terms/'
    | '/auth/signup/'
    | '/classes/$id/students'
    | '/notice/$id/edit'
    | '/students/$id/statistics'
    | '/tasks/$id/edit'
    | '/tasks/ranking/$id'
    | '/terms/$slug/edit'
    | '/classes/$id/'
    | '/notice/$id/'
    | '/vocabulary/categories/'
    | '/vocabulary/categories/$id/words/upload'
    | '/vocabulary/categories/$id/sentences/'
    | '/vocabulary/categories/$id/words/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/pending-approval'
    | '/support'
    | '/main'
    | '/mypage'
    | '/offices'
    | '/permission'
    | '/teachers'
    | '/auth/find-id'
    | '/auth/find-password'
    | '/auth/login'
    | '/term/$id'
    | '/vocabulary/print'
    | '/competition/$gameId'
    | '/competition/demo'
    | '/competition/groups'
    | '/notice/categories'
    | '/notice/new'
    | '/settings/test-mode'
    | '/tasks/calendar'
    | '/tasks/new'
    | '/tasks/stats'
    | '/tasks/upload'
    | '/auth/signup/parent-kmc-verification'
    | '/auth/signup/personal-sms-verification'
    | '/auth/signup/required-term'
    | '/auth/signup/signup-form'
    | '/auth/signup/under-14-sms-verification'
    | '/classes'
    | '/competition'
    | '/notice'
    | '/students'
    | '/tasks'
    | '/terms'
    | '/auth/signup'
    | '/classes/$id/students'
    | '/notice/$id/edit'
    | '/students/$id/statistics'
    | '/tasks/$id/edit'
    | '/tasks/ranking/$id'
    | '/terms/$slug/edit'
    | '/classes/$id'
    | '/notice/$id'
    | '/vocabulary/categories'
    | '/vocabulary/categories/$id/words/upload'
    | '/vocabulary/categories/$id/sentences'
    | '/vocabulary/categories/$id/words'
  id:
    | '__root__'
    | '/'
    | '/_content'
    | '/pending-approval'
    | '/support'
    | '/_content/main'
    | '/_content/mypage'
    | '/_content/offices'
    | '/_content/permission'
    | '/_content/teachers'
    | '/auth/find-id'
    | '/auth/find-password'
    | '/auth/login'
    | '/term/$id'
    | '/vocabulary/print'
    | '/_content/competition/$gameId'
    | '/_content/competition/demo'
    | '/_content/competition/groups'
    | '/_content/notice/categories'
    | '/_content/notice/new'
    | '/_content/settings/test-mode'
    | '/_content/tasks/calendar'
    | '/_content/tasks/new'
    | '/_content/tasks/stats'
    | '/_content/tasks/upload'
    | '/auth/signup/parent-kmc-verification'
    | '/auth/signup/personal-sms-verification'
    | '/auth/signup/required-term'
    | '/auth/signup/signup-form'
    | '/auth/signup/under-14-sms-verification'
    | '/_content/classes/'
    | '/_content/competition/'
    | '/_content/notice/'
    | '/_content/students/'
    | '/_content/tasks/'
    | '/_content/terms/'
    | '/auth/signup/'
    | '/_content/classes/$id/students'
    | '/_content/notice/$id/edit'
    | '/_content/students/$id/statistics'
    | '/_content/tasks/$id/edit'
    | '/_content/tasks/ranking/$id'
    | '/_content/terms/$slug/edit'
    | '/_content/classes/$id/'
    | '/_content/notice/$id/'
    | '/_content/vocabulary/categories/'
    | '/_content/vocabulary/categories/$id/words/upload'
    | '/_content/vocabulary/categories/$id/sentences/'
    | '/_content/vocabulary/categories/$id/words/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ContentRoute: typeof ContentRouteWithChildren
  PendingApprovalRoute: typeof PendingApprovalRoute
  SupportRoute: typeof SupportRoute
  AuthFindIdRoute: typeof AuthFindIdRoute
  AuthFindPasswordRoute: typeof AuthFindPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  TermIdRoute: typeof TermIdRoute
  VocabularyPrintRoute: typeof VocabularyPrintRoute
  AuthSignupParentKmcVerificationRoute: typeof AuthSignupParentKmcVerificationRoute
  AuthSignupPersonalSmsVerificationRoute: typeof AuthSignupPersonalSmsVerificationRoute
  AuthSignupRequiredTermRoute: typeof AuthSignupRequiredTermRoute
  AuthSignupSignupFormRoute: typeof AuthSignupSignupFormRoute
  AuthSignupUnder14SmsVerificationRoute: typeof AuthSignupUnder14SmsVerificationRoute
  AuthSignupIndexRoute: typeof AuthSignupIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_content': {
      id: '/_content'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ContentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pending-approval': {
      id: '/pending-approval'
      path: '/pending-approval'
      fullPath: '/pending-approval'
      preLoaderRoute: typeof PendingApprovalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_content/main': {
      id: '/_content/main'
      path: '/main'
      fullPath: '/main'
      preLoaderRoute: typeof ContentMainRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/mypage': {
      id: '/_content/mypage'
      path: '/mypage'
      fullPath: '/mypage'
      preLoaderRoute: typeof ContentMypageRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/offices': {
      id: '/_content/offices'
      path: '/offices'
      fullPath: '/offices'
      preLoaderRoute: typeof ContentOfficesRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/permission': {
      id: '/_content/permission'
      path: '/permission'
      fullPath: '/permission'
      preLoaderRoute: typeof ContentPermissionRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/teachers': {
      id: '/_content/teachers'
      path: '/teachers'
      fullPath: '/teachers'
      preLoaderRoute: typeof ContentTeachersRouteImport
      parentRoute: typeof ContentRoute
    }
    '/auth/find-id': {
      id: '/auth/find-id'
      path: '/auth/find-id'
      fullPath: '/auth/find-id'
      preLoaderRoute: typeof AuthFindIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/find-password': {
      id: '/auth/find-password'
      path: '/auth/find-password'
      fullPath: '/auth/find-password'
      preLoaderRoute: typeof AuthFindPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/term/$id': {
      id: '/term/$id'
      path: '/term/$id'
      fullPath: '/term/$id'
      preLoaderRoute: typeof TermIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vocabulary/print': {
      id: '/vocabulary/print'
      path: '/vocabulary/print'
      fullPath: '/vocabulary/print'
      preLoaderRoute: typeof VocabularyPrintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_content/classes/': {
      id: '/_content/classes/'
      path: '/classes'
      fullPath: '/classes/'
      preLoaderRoute: typeof ContentClassesIndexRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/competition/': {
      id: '/_content/competition/'
      path: '/competition'
      fullPath: '/competition/'
      preLoaderRoute: typeof ContentCompetitionIndexRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/competition/$gameId': {
      id: '/_content/competition/$gameId'
      path: '/competition/$gameId'
      fullPath: '/competition/$gameId'
      preLoaderRoute: typeof ContentCompetitionGameIdRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/competition/demo': {
      id: '/_content/competition/demo'
      path: '/competition/demo'
      fullPath: '/competition/demo'
      preLoaderRoute: typeof ContentCompetitionDemoRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/competition/groups': {
      id: '/_content/competition/groups'
      path: '/competition/groups'
      fullPath: '/competition/groups'
      preLoaderRoute: typeof ContentCompetitionGroupsRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/notice/': {
      id: '/_content/notice/'
      path: '/notice'
      fullPath: '/notice/'
      preLoaderRoute: typeof ContentNoticeIndexRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/notice/categories': {
      id: '/_content/notice/categories'
      path: '/notice/categories'
      fullPath: '/notice/categories'
      preLoaderRoute: typeof ContentNoticeCategoriesRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/notice/new': {
      id: '/_content/notice/new'
      path: '/notice/new'
      fullPath: '/notice/new'
      preLoaderRoute: typeof ContentNoticeNewRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/settings/test-mode': {
      id: '/_content/settings/test-mode'
      path: '/settings/test-mode'
      fullPath: '/settings/test-mode'
      preLoaderRoute: typeof ContentSettingsTestModeRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/students/': {
      id: '/_content/students/'
      path: '/students'
      fullPath: '/students/'
      preLoaderRoute: typeof ContentStudentsIndexRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/tasks/': {
      id: '/_content/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof ContentTasksIndexRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/tasks/calendar': {
      id: '/_content/tasks/calendar'
      path: '/tasks/calendar'
      fullPath: '/tasks/calendar'
      preLoaderRoute: typeof ContentTasksCalendarRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/tasks/new': {
      id: '/_content/tasks/new'
      path: '/tasks/new'
      fullPath: '/tasks/new'
      preLoaderRoute: typeof ContentTasksNewRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/tasks/stats': {
      id: '/_content/tasks/stats'
      path: '/tasks/stats'
      fullPath: '/tasks/stats'
      preLoaderRoute: typeof ContentTasksStatsRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/tasks/upload': {
      id: '/_content/tasks/upload'
      path: '/tasks/upload'
      fullPath: '/tasks/upload'
      preLoaderRoute: typeof ContentTasksUploadRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/terms/': {
      id: '/_content/terms/'
      path: '/terms'
      fullPath: '/terms/'
      preLoaderRoute: typeof ContentTermsIndexRouteImport
      parentRoute: typeof ContentRoute
    }
    '/auth/signup/': {
      id: '/auth/signup/'
      path: '/auth/signup'
      fullPath: '/auth/signup/'
      preLoaderRoute: typeof AuthSignupIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signup/parent-kmc-verification': {
      id: '/auth/signup/parent-kmc-verification'
      path: '/auth/signup/parent-kmc-verification'
      fullPath: '/auth/signup/parent-kmc-verification'
      preLoaderRoute: typeof AuthSignupParentKmcVerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signup/personal-sms-verification': {
      id: '/auth/signup/personal-sms-verification'
      path: '/auth/signup/personal-sms-verification'
      fullPath: '/auth/signup/personal-sms-verification'
      preLoaderRoute: typeof AuthSignupPersonalSmsVerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signup/required-term': {
      id: '/auth/signup/required-term'
      path: '/auth/signup/required-term'
      fullPath: '/auth/signup/required-term'
      preLoaderRoute: typeof AuthSignupRequiredTermRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signup/signup-form': {
      id: '/auth/signup/signup-form'
      path: '/auth/signup/signup-form'
      fullPath: '/auth/signup/signup-form'
      preLoaderRoute: typeof AuthSignupSignupFormRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signup/under-14-sms-verification': {
      id: '/auth/signup/under-14-sms-verification'
      path: '/auth/signup/under-14-sms-verification'
      fullPath: '/auth/signup/under-14-sms-verification'
      preLoaderRoute: typeof AuthSignupUnder14SmsVerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_content/classes/$id/': {
      id: '/_content/classes/$id/'
      path: '/classes/$id'
      fullPath: '/classes/$id/'
      preLoaderRoute: typeof ContentClassesIdIndexRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/classes/$id/students': {
      id: '/_content/classes/$id/students'
      path: '/classes/$id/students'
      fullPath: '/classes/$id/students'
      preLoaderRoute: typeof ContentClassesIdStudentsRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/notice/$id/': {
      id: '/_content/notice/$id/'
      path: '/notice/$id'
      fullPath: '/notice/$id/'
      preLoaderRoute: typeof ContentNoticeIdIndexRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/notice/$id/edit': {
      id: '/_content/notice/$id/edit'
      path: '/notice/$id/edit'
      fullPath: '/notice/$id/edit'
      preLoaderRoute: typeof ContentNoticeIdEditRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/students/$id/statistics': {
      id: '/_content/students/$id/statistics'
      path: '/students/$id/statistics'
      fullPath: '/students/$id/statistics'
      preLoaderRoute: typeof ContentStudentsIdStatisticsRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/tasks/$id/edit': {
      id: '/_content/tasks/$id/edit'
      path: '/tasks/$id/edit'
      fullPath: '/tasks/$id/edit'
      preLoaderRoute: typeof ContentTasksIdEditRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/tasks/ranking/$id': {
      id: '/_content/tasks/ranking/$id'
      path: '/tasks/ranking/$id'
      fullPath: '/tasks/ranking/$id'
      preLoaderRoute: typeof ContentTasksRankingIdRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/terms/$slug/edit': {
      id: '/_content/terms/$slug/edit'
      path: '/terms/$slug/edit'
      fullPath: '/terms/$slug/edit'
      preLoaderRoute: typeof ContentTermsSlugEditRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/vocabulary/categories/': {
      id: '/_content/vocabulary/categories/'
      path: '/vocabulary/categories'
      fullPath: '/vocabulary/categories/'
      preLoaderRoute: typeof ContentVocabularyCategoriesIndexRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/vocabulary/categories/$id/sentences/': {
      id: '/_content/vocabulary/categories/$id/sentences/'
      path: '/vocabulary/categories/$id/sentences'
      fullPath: '/vocabulary/categories/$id/sentences/'
      preLoaderRoute: typeof ContentVocabularyCategoriesIdSentencesIndexRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/vocabulary/categories/$id/words/': {
      id: '/_content/vocabulary/categories/$id/words/'
      path: '/vocabulary/categories/$id/words'
      fullPath: '/vocabulary/categories/$id/words/'
      preLoaderRoute: typeof ContentVocabularyCategoriesIdWordsIndexRouteImport
      parentRoute: typeof ContentRoute
    }
    '/_content/vocabulary/categories/$id/words/upload': {
      id: '/_content/vocabulary/categories/$id/words/upload'
      path: '/vocabulary/categories/$id/words/upload'
      fullPath: '/vocabulary/categories/$id/words/upload'
      preLoaderRoute: typeof ContentVocabularyCategoriesIdWordsUploadRouteImport
      parentRoute: typeof ContentRoute
    }
  }
}

interface ContentRouteChildren {
  ContentMainRoute: typeof ContentMainRoute
  ContentMypageRoute: typeof ContentMypageRoute
  ContentOfficesRoute: typeof ContentOfficesRoute
  ContentPermissionRoute: typeof ContentPermissionRoute
  ContentTeachersRoute: typeof ContentTeachersRoute
  ContentCompetitionGameIdRoute: typeof ContentCompetitionGameIdRoute
  ContentCompetitionDemoRoute: typeof ContentCompetitionDemoRoute
  ContentCompetitionGroupsRoute: typeof ContentCompetitionGroupsRoute
  ContentNoticeCategoriesRoute: typeof ContentNoticeCategoriesRoute
  ContentNoticeNewRoute: typeof ContentNoticeNewRoute
  ContentSettingsTestModeRoute: typeof ContentSettingsTestModeRoute
  ContentTasksCalendarRoute: typeof ContentTasksCalendarRoute
  ContentTasksNewRoute: typeof ContentTasksNewRoute
  ContentTasksStatsRoute: typeof ContentTasksStatsRoute
  ContentTasksUploadRoute: typeof ContentTasksUploadRoute
  ContentClassesIndexRoute: typeof ContentClassesIndexRoute
  ContentCompetitionIndexRoute: typeof ContentCompetitionIndexRoute
  ContentNoticeIndexRoute: typeof ContentNoticeIndexRoute
  ContentStudentsIndexRoute: typeof ContentStudentsIndexRoute
  ContentTasksIndexRoute: typeof ContentTasksIndexRoute
  ContentTermsIndexRoute: typeof ContentTermsIndexRoute
  ContentClassesIdStudentsRoute: typeof ContentClassesIdStudentsRoute
  ContentNoticeIdEditRoute: typeof ContentNoticeIdEditRoute
  ContentStudentsIdStatisticsRoute: typeof ContentStudentsIdStatisticsRoute
  ContentTasksIdEditRoute: typeof ContentTasksIdEditRoute
  ContentTasksRankingIdRoute: typeof ContentTasksRankingIdRoute
  ContentTermsSlugEditRoute: typeof ContentTermsSlugEditRoute
  ContentClassesIdIndexRoute: typeof ContentClassesIdIndexRoute
  ContentNoticeIdIndexRoute: typeof ContentNoticeIdIndexRoute
  ContentVocabularyCategoriesIndexRoute: typeof ContentVocabularyCategoriesIndexRoute
  ContentVocabularyCategoriesIdWordsUploadRoute: typeof ContentVocabularyCategoriesIdWordsUploadRoute
  ContentVocabularyCategoriesIdSentencesIndexRoute: typeof ContentVocabularyCategoriesIdSentencesIndexRoute
  ContentVocabularyCategoriesIdWordsIndexRoute: typeof ContentVocabularyCategoriesIdWordsIndexRoute
}

const ContentRouteChildren: ContentRouteChildren = {
  ContentMainRoute: ContentMainRoute,
  ContentMypageRoute: ContentMypageRoute,
  ContentOfficesRoute: ContentOfficesRoute,
  ContentPermissionRoute: ContentPermissionRoute,
  ContentTeachersRoute: ContentTeachersRoute,
  ContentCompetitionGameIdRoute: ContentCompetitionGameIdRoute,
  ContentCompetitionDemoRoute: ContentCompetitionDemoRoute,
  ContentCompetitionGroupsRoute: ContentCompetitionGroupsRoute,
  ContentNoticeCategoriesRoute: ContentNoticeCategoriesRoute,
  ContentNoticeNewRoute: ContentNoticeNewRoute,
  ContentSettingsTestModeRoute: ContentSettingsTestModeRoute,
  ContentTasksCalendarRoute: ContentTasksCalendarRoute,
  ContentTasksNewRoute: ContentTasksNewRoute,
  ContentTasksStatsRoute: ContentTasksStatsRoute,
  ContentTasksUploadRoute: ContentTasksUploadRoute,
  ContentClassesIndexRoute: ContentClassesIndexRoute,
  ContentCompetitionIndexRoute: ContentCompetitionIndexRoute,
  ContentNoticeIndexRoute: ContentNoticeIndexRoute,
  ContentStudentsIndexRoute: ContentStudentsIndexRoute,
  ContentTasksIndexRoute: ContentTasksIndexRoute,
  ContentTermsIndexRoute: ContentTermsIndexRoute,
  ContentClassesIdStudentsRoute: ContentClassesIdStudentsRoute,
  ContentNoticeIdEditRoute: ContentNoticeIdEditRoute,
  ContentStudentsIdStatisticsRoute: ContentStudentsIdStatisticsRoute,
  ContentTasksIdEditRoute: ContentTasksIdEditRoute,
  ContentTasksRankingIdRoute: ContentTasksRankingIdRoute,
  ContentTermsSlugEditRoute: ContentTermsSlugEditRoute,
  ContentClassesIdIndexRoute: ContentClassesIdIndexRoute,
  ContentNoticeIdIndexRoute: ContentNoticeIdIndexRoute,
  ContentVocabularyCategoriesIndexRoute: ContentVocabularyCategoriesIndexRoute,
  ContentVocabularyCategoriesIdWordsUploadRoute:
    ContentVocabularyCategoriesIdWordsUploadRoute,
  ContentVocabularyCategoriesIdSentencesIndexRoute:
    ContentVocabularyCategoriesIdSentencesIndexRoute,
  ContentVocabularyCategoriesIdWordsIndexRoute:
    ContentVocabularyCategoriesIdWordsIndexRoute,
}

const ContentRouteWithChildren =
  ContentRoute._addFileChildren(ContentRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ContentRoute: ContentRouteWithChildren,
  PendingApprovalRoute: PendingApprovalRoute,
  SupportRoute: SupportRoute,
  AuthFindIdRoute: AuthFindIdRoute,
  AuthFindPasswordRoute: AuthFindPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  TermIdRoute: TermIdRoute,
  VocabularyPrintRoute: VocabularyPrintRoute,
  AuthSignupParentKmcVerificationRoute: AuthSignupParentKmcVerificationRoute,
  AuthSignupPersonalSmsVerificationRoute:
    AuthSignupPersonalSmsVerificationRoute,
  AuthSignupRequiredTermRoute: AuthSignupRequiredTermRoute,
  AuthSignupSignupFormRoute: AuthSignupSignupFormRoute,
  AuthSignupUnder14SmsVerificationRoute: AuthSignupUnder14SmsVerificationRoute,
  AuthSignupIndexRoute: AuthSignupIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
